import { useEffect, useState } from "react";
import {getSchoolParticipationScoreService} from "../../../../services/school.service";

function transformParticipationData(rawData) {
    if (!rawData || !rawData[0]) return {};

    const total = rawData[0].total;

    // By Month
    const byMonth = (rawData[0].by_month || []).map((m) => ({
        month: m.month,
        participants: m.user_count,
        percentage: Math.round(m.ratio * 1000) / 10, // for 0.75 -> 75.0
    }));

    // By Age
    const byAge = (rawData[0].by_age || []).map((a) => ({
        age: a.age,
        participants: a.user_count,
        percentage: Math.round(a.ratio * 1000) / 10,
    }));

    // By Grade Level (section_level)
    const byGradeLevel = (rawData[0].by_section_level || []).map((g) => ({
        grade: g.section_level,
        participants: g.user_count,
        percentage: Math.round(g.ratio * 1000) / 10,
    }));

    // By Class (section_code)
    const byClass = (rawData[0].by_section_code || []).map((c) => ({
        class: c.section_code,
        participants: c.user_count,
        percentage: Math.round(c.ratio * 1000) / 10,
    }));

    return { total, byMonth, byAge, byGradeLevel, byClass };
}

export function useParticipationData(org_code, module_code, institute_code, start_date, end_date, dist_keys) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!org_code || !module_code || !institute_code) {
            setLoading(false);
            setData(null);
            return;
        }
        setLoading(true);
        setError(null);
        getSchoolParticipationScoreService(org_code, module_code, institute_code, start_date, end_date, dist_keys)
            .then((res) => {
                // API returns data at res.data
                setData(transformParticipationData(res.data.participation));
                setLoading(false);
            })
            .catch((err) => {
                setError(err);
                setLoading(false);
            });
    }, [org_code, module_code, institute_code, start_date, end_date, dist_keys]);

    return { data, loading, error };
}
